import React from 'react';
import * as styles from './styles.css';
import { Body1 } from '@cian/ui-kit';

export interface IPeculiarityRowProps {
  title: string | null;
}

export function PeculiarityRow({ title }: IPeculiarityRowProps) {
  return (
    <div className={styles['container']}>
      <Body1>{title}</Body1>
    </div>
  );
}
